<template>
  <div class="block_screen">
    <div id="map5">
      <img id="dummyimage1" class="img-center" src="assets/backup_screens/scr32.png" alt="">
    </div>
    <div id="map6" class="display_none">
      <div class="">
        <div class="final_page">
          <div class="container--small">
            <i class="icon-Product-Icon_HDM_Suite main-icon f-blue"></i>
            <p class="desc">Paragon</p>
            <h1>Hard Disk Manager™ <b>Advanced</b></h1>
            <p>Everything you need for reliable data protection and professional PC management!</p>
            <ul class="hdm_list">
              <li>Covers up to three personal computers</li>
              <li>Empowered data safety and disaster recovery software</li>
              <li>Powerful partition management</li>
              <li>Full spectrum of virtual and physical migration operations</li>
            </ul>
          </div>
          <div class="sidebar">
            <div class="price">&dollar;79,95</div>
            <a data-name="buy now" href="https://www.paragon-software.com/in-app/HDM17/tour.html" class="btn btn_orange">buy now</a>
            <a data-name="View other scenarios" href="" @click.prevent="changeScreen(0)">View other scenarios</a>
          </div>
          <div class="screen1"></div>
          <div class="screen2"></div>
          <div class="screen3"></div>
        </div>
      </div>
    </div>
    <div class="btn_left">
      <a data-name="back" href="" @click.prevent="changeScreen(26)"
         class="btn btn_orange">Back</a>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import $ from 'jquery'
  export default {
    mounted() {
      setInterval(function(){
        if($('#map6').hasClass('display_none')) {
          $('#map5').toggleClass('display_none');
          $('#map6').toggleClass('display_none');
        }
        return false;
      },2000);
    },
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
